// `question_options.exclusive`, `questions.helper_text` and `questions.required` are
// columns this app adds ahead of a matching Laravel migration.
/** Max length of a write-in (single-line) answer (spec FR-008). */
export const WRITE_IN_MAX_LENGTH = 255;
// --- Raw type mapping -------------------------------------------------------
// Verified against the Laravel `Question` model constants (ethics-quotient,
// app/Domains/Survey/Models/Question.php). The platform has 7 answer types in 3
// groups; the four general-purpose ones and the Org-Profile INDUSTRY selection are
// rendered, and the rest (MULTI_TEXTBOX, CASCADING_DROPDOWN, FILE, GROUP, parent) are
// treated as unknown/unsupported so they render read-only without error.
const RAW_TYPE_ALIASES = {
    RADIO: 'single_select',
    MENU: 'single_select',
    CHECKBOX: 'multi_select',
    TEXTBOX: 'write_in',
    ESSAY: 'essay',
    INDUSTRY: 'industry',
};
/** Map a raw platform `questions.type` to the canonical union; 'unknown' if unmapped. */
export function toQuestionType(raw) {
    if (typeof raw !== 'string')
        return 'unknown';
    return RAW_TYPE_ALIASES[raw.trim().toUpperCase()] ?? 'unknown';
}
//# sourceMappingURL=question.js.map